const Master = {
  namespaced: true,
  state: {
    master: {},
    year: [],
  },
  getters: {
    getMaster(state) {
      return state.master
    },
    getYear(state) {
      return state.year
    },
  },
  mutations: {
    setMaster(state, master) {
      state.master = master
    },
    setYear(state, year) {
      state.year = year
    },
  },
  actions: {},
}

export default Master
